module.exports = __webpack_public_path__ + "img/signal-1.91ffee82.svg";